import ImageWithFallback from "components/ImageWithFallback"
import React from "react"
import {Component} from "react"
import {Link} from "react-router-dom"
import {Card} from "semantic-ui-react"

export default class CategoryCard extends Component {

	render() {
		const {itemsPerRow, category, hasParents, className = "", title = true, fallback = "//placehold.it/420x240/f5f5f5/&text=X"} = this.props
		console.log("CategoryCard render", {itemsPerRow, category, hasParents, className, title, fallback})
		if ( !category.active ) return null
    	if ( category.isHidden ) return null
		if ( !hasParents ) {
			return <Card style={{border: "none", backgroundColor: "#f3f0e7"}} className={` ${itemsPerRow && itemsPerRow == 4 ? "CategoryCard-four-columns" : "CategoryCard"} `} as={Link}
						 to={`/collection/${category.map_id}`}>
												<ImageWithFallback className={itemsPerRow && itemsPerRow == 4 ? "img-box-four" : "img-box"} src={category.img_src} 
					fallback={<ImageWithFallback style={{backgroundColor: "#d0e9b9"}} className={itemsPerRow && itemsPerRow == 4 ? "img-box-four" : "img-box"} src={category.img_src} fallback={fallback} />} />
				
				{title && <div className={"pa3 tc text-box"}>
					<span className="category-title">{category.desc.short_des}</span>
				</div>}
				<div className="pb4"></div>
			</Card>
		}

		if ( category.getParents ) {
			let parents = category.getParents()
			return <Card style={{border: "none", backgroundColor: "#f3f0e7"}} className={` ${itemsPerRow && itemsPerRow == 4 ? "CategoryCard-four-columns" : "CategoryCard"} `} as={Link}
						 to={`/collection/${parents.map( id => `${id}/` ).join( "" )}${category.map_id}`}>
								<ImageWithFallback className={itemsPerRow && itemsPerRow == 4 ? "img-box-four" : "img-box"} src={category.img_src} 
					fallback={<ImageWithFallback style={{backgroundColor: "#d0e9b9", border: "none"}} className={itemsPerRow && itemsPerRow == 4 ? "img-box-four" : "img-box"} src={category.img_src} fallback={fallback} />} />
				{title && <div className={"pa3 text-box"}>
					<span className={"category-title"}>{category.desc.short_des}</span>
				</div>}
			</Card>
		}

		return null
	}
}


// WEBPACK FOOTER //
// ./src/theme/lucht-test/plugin/CategoryShortcuts/CategoryCard.js